import React, { ReactElement, useCallback } from 'react';
import isEqual from 'lodash.isequal';
import { useActiveLanguage, useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { useNewsletterSubscriptionAction } from 'b2b-apps/shop/newsletter/hooks';
import {
  EnhancedComponentProps,
  EnhancedComponentType,
  FormValuesType,
  InjectedProps,
  WrappedComponentType,
} from './';

export enum FIELD_NAME {
  emailNewsletter = 'emailNewsletter',
}

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const subscribe = useNewsletterSubscriptionAction();
    const language = useActiveLanguage();

    const handleSubmit = useCallback((values: FormValuesType): void => {
      subscribe(values[FIELD_NAME.emailNewsletter], language);
    }, [subscribe, language]);

    const t = useTranslate();
    const text = {
      email: t('E-mail address'),
      resend: t('Resend'),
      subscribe: t('Subscribe'),
      emailIsNotValid: t('Email is not valid'),
      emailIsRequired: t('Email is required'),
    };

    const injectedProps: InjectedProps = {
      onSubmit: handleSubmit,
      text,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};
